// extracted by mini-css-extract-plugin
module.exports = {"landingpageLayout":"Home_landingpageLayout__69249","landingpageSmallBenefitsHint":"Home_landingpageSmallBenefitsHint__b8b6a"};